<template>
  <div class="category-sidebar">
    <h5 class="fw-bold mb-3">Catégories</h5>
    <ul class="list-group list-group-flush">
      <li
          class="list-group-item d-flex align-items-center"
          :class="{ active: selected === null }"
          @click="select(null)"
      >
        <i class="fe fe-grid me-2"></i> Toutes les catégories
      </li>
      <li
          v-for="cat in categories"
          :key="cat.code"
          class="list-group-item d-flex align-items-center"
          :class="{ active: selected === cat.code }"
          @click="select(cat.code)"
      >
        <i :class="cat.icon || 'fe fe-tag'" class="me-2"></i> {{ cat.label }}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "CategorySidebar",
    props: {
      categories: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        selected: null
      };
    },
    methods: {
      select(code) {
        this.selected = code;
        this.$emit("select-category", code);
      }
    }
  };
</script>

<style scoped>
.category-sidebar {
  background: #f9f9f9;
  padding: 1rem;
  border-radius: 8px;
}
.list-group-item {
  cursor: pointer;
  transition: background 0.2s;
}
.list-group-item.active {
  background-color: #007bff;
  color: white;
}
.list-group-item:hover {
  background-color: #e6e6e6;
}
</style>
